import { Outlet } from "react-router-dom";

import { AppStateProvider } from "@/components/context/AppContext";
import SWRProvider from "@/components/providers/SWRProvider";
import { Toaster } from "react-hot-toast";
import { CookieConsent } from "@/components/analytics/CookieConsent";
import ReplayTracker from "@/components/analytics/ReplayTracker";
import WebsiteTracker from "@/components/analytics/WebsiteTracker";

import ContextGate from "../app/ContextGate";
import ProtectedRoute from "../app/ProtectedRoute";

// RootShell replaces app/layout.jsx + app/ProtectedRoute.jsx semantics.
// In React Router, child routes render inside <Outlet />.
export default function RootShell() {
  return (
    <SWRProvider>
      <AppStateProvider>
        <CookieConsent />
        <WebsiteTracker />
        <ReplayTracker />
        <ContextGate>
          <Toaster position="top-right" />
          <ProtectedRoute>
            <Outlet />
          </ProtectedRoute>
        </ContextGate>
      </AppStateProvider>
    </SWRProvider>
  );
}
